module.exports = __webpack_public_path__ + "img/6.fc5978e6.png";